/** Shared admin tab routing — keep in sync with AdminPanel allowed tabs. */
export const ADMIN_TAB_VALUES = [
  'dashboard',
  'applications',
  'apartments',
  'visits',
  'property_managers',
  'users',
];

export function resolveAdminActiveTab(pathname, search = '') {
  if (pathname.startsWith('/admin/apartments')) return 'apartments';
  const tab = new URLSearchParams(search).get('tab');
  if (tab && ADMIN_TAB_VALUES.includes(tab)) return tab;
  return 'dashboard';
}

export function getAdminTabPath(tab) {
  if (tab === 'apartments') return '/admin/apartments';
  if (tab === 'dashboard') return '/admin';
  return `/admin?tab=${tab}`;
}
